import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=383d62e0&scoped=true&v-if=isShowProductTitle&"
import script from "./ProductTitle.vue?vue&type=script&lang=js&"
export * from "./ProductTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&id=383d62e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383d62e0",
  null
  
)

export default component.exports